import { lazyLoadLinks } from './lazy-load-links';
import onDomContentLoaded from '../utilities/onDomContentLoaded';
import '../../scss/common/main.scss';

onDomContentLoaded(() => {
    lazyLoadLinks();
});
